import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import {
  getOfferedCampaigns,
  getEventsInProgress,
  getEventsAwaitingReview,
  getEventsCompleted,
  getEventsCanceled,
  getEventsStatistics,
} from 'Redux/actions/influencerActions'
import { useDispatch, useSelector } from 'react-redux'
import {
  getInfluencerCampaigns,
  getInfluencerEventStatistics,
  getInfluencerCampaignsInProgress,
  getInfluencerCampaignsAwaitingReview,
  getInfluencerCampaignsCompleted,
  getInfluencerCampaignsCanceled,
} from 'Redux/selectors/influencer'
import { getTabs } from 'Containers/Tracks/helpers'
import { TracksList } from '../TracksList'

import { TabKeys, TracksTableProps } from './types'

import {
  TrackTableContainer,
  Number,
  StyledTabs,
  StyledTabsItem,
  TabName,
} from './styles'

export const TracksTable: FunctionComponent<TracksTableProps> = ({ t }) => {
  const dispatch = useDispatch()

  const [currentTubKey, setCurrentTubKey] = useState<TabKeys>(TabKeys.new)

  const statisticsEvents = useSelector(getInfluencerEventStatistics)
  const campaignsForNewTracksTub = useSelector(getInfluencerCampaigns)
  const campaignsForInProgressTub = useSelector(
    getInfluencerCampaignsInProgress
  )
  const campaignsForAwaitingReviewTub = useSelector(
    getInfluencerCampaignsAwaitingReview
  )
  const campaignsForCompletedTub = useSelector(getInfluencerCampaignsCompleted)
  const campaignsForCanceledTub = useSelector(getInfluencerCampaignsCanceled)

  useEffect(() => {
    if (currentTubKey === TabKeys.new) {
      dispatch(getOfferedCampaigns())
    }
    if (currentTubKey === TabKeys.in_progress) {
      dispatch(getEventsInProgress())
    }

    if (currentTubKey === TabKeys.awaiting) {
      dispatch(getEventsAwaitingReview())
    }

    if (currentTubKey === TabKeys.canceled) {
      dispatch(getEventsCanceled())
    }
    if (currentTubKey === TabKeys.completed) {
      dispatch(getEventsCompleted())
    }
  }, [currentTubKey])

  const getCurrentEntities = (key: TabKeys) => {
    if (key === TabKeys.new) {
      return campaignsForNewTracksTub?.sort(
        (prev, next) =>
          new Date(next.createdAt).valueOf() -
          new Date(prev.createdAt).valueOf()
      )
    }
    if (key === TabKeys.in_progress)
      return campaignsForInProgressTub?.sort(
        (prev, next) =>
          new Date(next.createdAt).valueOf() -
          new Date(prev.createdAt).valueOf()
      )

    if (key === TabKeys.awaiting)
      return campaignsForAwaitingReviewTub?.sort(
        (prev, next) =>
          new Date(next.createdAt).valueOf() -
          new Date(prev.createdAt).valueOf()
      )

    if (key === TabKeys.completed)
      return campaignsForCompletedTub?.sort(
        (prev, next) =>
          new Date(next.createdAt).valueOf() -
          new Date(prev.createdAt).valueOf()
      )

    if (key === TabKeys.canceled)
      return campaignsForCanceledTub?.sort(
        (prev, next) =>
          new Date(next.createdAt).valueOf() -
          new Date(prev.createdAt).valueOf()
      )

    return campaignsForNewTracksTub?.sort(
      (prev, next) =>
        new Date(next.createdAt).valueOf() - new Date(prev.createdAt).valueOf()
    )
  }

  const tabs = useMemo(() => getTabs(statisticsEvents), [statisticsEvents])

  useEffect(() => {
    dispatch(getEventsStatistics())
  }, [])

  return (
    <TrackTableContainer>
      <StyledTabs
        defaultActiveKey={TabKeys.new}
        // @ts-ignore
        onChange={(e: TabKeys) => setCurrentTubKey(e)}
      >
        {tabs.map(({ key, title, numbers }) => (
          <StyledTabsItem
            key={key}
            tab={
              <>
                <TabName>{t(title)}</TabName>
                <Number>{numbers}</Number>
              </>
            }
          >
            <TracksList
              campaigns={getCurrentEntities(key)}
              currentTubKey={currentTubKey}
            />
          </StyledTabsItem>
        ))}
      </StyledTabs>
    </TrackTableContainer>
  )
}
